export class ValidPlanogramRequest{
    planogramId : string = '';
    constructor(planogramId: string){
        this.planogramId = planogramId;
    }
}